import { render, staticRenderFns } from "./ontick-pin-code-input.component.vue?vue&type=template&id=2992110f&scoped=true"
import script from "./ontick-pin-code-input.component.vue?vue&type=script&lang=js"
export * from "./ontick-pin-code-input.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-pin-code-input.component.vue?vue&type=style&index=0&id=2992110f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2992110f",
  null
  
)

export default component.exports